import axiosInstance from '@/utils/request/bus'


class SystemHttp {
  constructor() {
    this.axiosInstance = axiosInstance;
  }


  /**
   * 封装：通用请求工具函数 
   * >>> 可以单独设置&处理自定义请求/响应回调
   * @param {*} method 
   * @param {*} url 
   * @param {*} param 
   * @param {*} axiosConfig 
   * @returns 
   */
  request(method, url, param, axiosConfig) {
    const config = {
      method,
      url,
      ...param,
      ...axiosConfig
    };

    return new Promise((resolve, reject) => {
      this.axiosInstance.request(config).then((response) => {
          resolve(response);
      }).catch(error => {
          reject(error);
      });
    });
  }

  /**
   * 封装：GET请求工具函数 
   * @param {*} url 
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  get(url, params, config) {
    return this.request("get", url, { params }, config);
  }


  /**
   * 封装：POST请求工具函数 
   * @param {*} url 
   * @param {*} params 
   * @param {*} config 
   * @param {*} urlParams 
   * @returns 
   */
  post(url, params, config, urlParams) {
    const option = {
      data: params,
      ...(urlParams ? { params: urlParams } : {})
    }
    return this.request("post", url, option, config);
  }


  /**
   * 封装：PUT请求工具函数 
   * @param {*} url 
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  put(url, params, config) {
    return this.request("put", url, { data: params }, config);
  }



}


export const httpBus = new SystemHttp();

